import { render } from "./UserInfoFields.html?vue&type=template&id=0fc97d19&external"
import script from "./UserInfoFields.js?vue&type=script&lang=js&external"
export * from "./UserInfoFields.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__